import useStore from "../hooks/useStore";

const WebinarDescription = () => {
  const activeWebinar = useStore((state) => state.activeWebinar);
  // const getTextFromHtml = () => {
  //   const description = activeWebinar?.MarketingDescription;
  //   const el = document.createElement("div");
  //   el.innerHTML = description;

  //   let textContent = "";

  //   el.childNodes.forEach((node, i) => {
  //     if (node.textContent?.trim() === "" && node.textContent?.trim() === " ")
  //       return;

  //     if (i === 0) {
  //       textContent = node.textContent?.trim() || "";
  //       return;
  //     }

  //     if (i > 0) {
  //       textContent = textContent + "\n" + node.textContent?.trim();
  //       return;
  //     }
  //   });

  //   return textContent;
  // };

  // const formatText = () => {
  //   const textContent = getTextFromHtml();

  //   if (!textContent) return "";

  //   const text = textContent.split("\n");

  //   return text.map((line, i) => formatLine(line, i));
  // };

  // const formatLine = (line: string, key: number) => {
  //   if (line.trim() === "") return null;

  //   // Instructor row
  //   if (line.toLowerCase().startsWith("instructor:")) {
  //     const assigmentsKeyWord = "Instructor assignments";
  //     const hasAssignmentsRow = line
  //       .toLowerCase()
  //       .includes(assigmentsKeyWord.toLowerCase());

  //     const assignmentsTextArray = line.split(assigmentsKeyWord) ?? [];
  //     const assignmentsText =
  //       assignmentsTextArray.length > 0
  //         ? assigmentsKeyWord + assignmentsTextArray[1]
  //         : "";

  //     return (
  //       <p key={key} className="tw-py-2">
  //         <strong>{assignmentsTextArray[0]}</strong>
  //         {hasAssignmentsRow && (
  //           <>
  //             <br />
  //             <i>{assignmentsText}</i>
  //           </>
  //         )}
  //       </p>
  //     );
  //   }

  //   // Notes row
  //   if (line.toLowerCase().startsWith("note:")) {
  //     return (
  //       <p key={key} className="tw-leading-5">
  //         <small>{line}</small>
  //       </p>
  //     );
  //   }

  //   return (
  //     <p key={key} className="tw-py-2">
  //       {line}
  //     </p>
  //   );
  // };

  return (
    <div
      className="tw-text-tr-date tw-text-md"
      dangerouslySetInnerHTML={{ __html: activeWebinar?.MarketingDescription }}
    ></div>
  );
};

export default WebinarDescription;
